import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Years } from '../components/Years';
import { Journals } from '../components/Journals';
import { Button } from 'antd';
import axios from '../../axios';
import '../stylesheets/AdminPage.css';

export function AdminPage() {
  const [years, setYears] = useState([]);
  const [journals, setJournals] = useState([]);
  const [currentYear, setCurrentYear] = useState([]);
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    loadingData();
  }, [])

  async function loadingData() {
    // years
    let yearsResp = await axios.get('years');
    setYears(yearsResp.data.reverse());
    setCurrentYear(yearsResp.data[0].year);

    // all newspapers of the current year
    const journalsResp = await axios.get(`journals/year/${yearsResp.data[0]['year']}`);
    setJournals(journalsResp.data);
  }

  /** 
  ===========================================
   * @years
  ===========================================
  **/

  async function onChangeCurrentYear(year) {
    setCurrentYear(year);

    // get newspapers of the current year
    const journalsResp = await axios.get(`journals/year/${year}`);
    setJournals(journalsResp.data);
  }

  async function addNewYear() {
    let newYear;

    while (true) {
      newYear = prompt('Ավելացրեք նոր տարին:');

      if (newYear === null) {
        return;
      }

      if (!isNaN(Number(newYear)) && newYear !== '') {
        break;
      } else {
        alert('Գրեք միայն թվեր:');
      }
    }

    try {
      await axios.post(`years/add/${newYear}`, {}, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      loadingData();
    } catch (error) {
      alert('Տեղի ունեցավ սխալ հարցումն ուղարկելիս:');
      console.log('Error sending request.', error);
    }
  }

  async function editSingleYear(currentYear) {
    let changingYear = currentYear;

    while (true) {
      changingYear = +prompt('Գրեք փոփոխվող տարին:', currentYear);

      if (!isNaN(changingYear) && changingYear !== null && changingYear !== '' && changingYear !== 0) {
        break;
      } else {
        alert('Գրեք միայն թվեր:');
      }
    }

    try {
      await axios.put(`years/edit/${currentYear}`, { year: changingYear }, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      loadingData();
    } catch (error) {
      alert('Տեղի ունեցավ սխալ հարցումն ուղարկելիս:');
      console.log('Error sending request.', error);
    }
  }

  async function deleteSingleYear(year) {
    const confirm = window.confirm(`Դուք համոզվա՞ծ եք, որ ուզում եք ջնջել ${year} թվականը:`);

    if (confirm) {
      try {
        await axios.delete(`years/remove/${year}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        loadingData();
      } catch (error) {
        alert('Տեղի ունեցավ սխալ հարցումն ուղարկելիս:');
        console.log('Error sending request:', error);
      }
    }
  }

  /** 
  ===========================================
   * @journals
  ===========================================
  **/

  async function deleteSingleJournal(id) {
    const deletedJournal = journals.find(journal => journal._id !== id);

    const confirm = window.confirm(
      `Դուք համոզվա՞ծ եք, որ ուզում եք ջնջել ${deletedJournal.title} (${deletedJournal.year}) ամսագիրը:`
    );

    if (confirm) {
      try {
        await axios.delete(`journals/remove/${id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        loadingData();
      } catch (error) {
        alert('Տեղի ունեցավ սխալ հարցումն ուղարկելիս:');
        console.log('Error sending request:', error);
      }
    }
  }

  return (
    <div className='AdminPage'>
      <div className='controlsContainer'>
        <Button type='primary' onClick={addNewYear}>Ավելացնել նոր տարի</Button>

        <Button type='primary' onClick={() => navigate('/admin/add/journal')}>
          Ավելացնել նոր ամսաթերթ
        </Button>
      </div>

      <div className='container'>
        <Years
          years={years}
          currentYear={currentYear}
          editSingleYear={editSingleYear}
          deleteSingleYear={deleteSingleYear}
          onChangeCurrentYear={onChangeCurrentYear}
        />

        <Journals
          journals={journals}
          deleteSingleJournal={deleteSingleJournal}
        />
      </div>
    </div>
  )
}
